import { Box, ListItemText, Stack, Tooltip, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React from "react";

import Avatar from "../Avatar";
import UploadImage from "./uploadImage";
import { hasImage } from "../../utils";
import MergeBoard from "../../features/board/components/mergeBoard/MergeBoard";
import "./header.scss";
import { FeedbackDialogContent } from "./FeedBackDialogContent.js";
import { TooltipName } from "../../utils/Enums.js";
import CustomMenu from "../Menu/index.js";
import CustomMenuItem from "../Menu/CustomMenuItem.js";
import FormDialog from "../Dialog/FormDialog.js";
import { CustomButton } from "../Button/Button.js";
import { schema } from "../../schemas/feedbackSchema.js";
import { ProfileMenuItem } from "./components/ProfileMenuItem.js";
import { profileMenuList } from "./components/menuList.js";
import { useProfileMenuState } from "./hooks/useProfileMenuState";
import Notification from './components/Notification';

function Profile() {
  const {
    anchorEl,
    closeFeedBackDialog,
    closeLogoutDialog,
    closeMergeBoard,
    handleClick,
    handleClose,
    handleLogout,
    handleMenuClick,
    isLogoutLoading,
    isMobile,
    openMenu,
    openMergeBoard,
    showFeedBackDialog,
    showLogoutDialog,
    user,
    userName,
  } = useProfileMenuState();

  const handleFeedBackForm = React.useCallback(() => {
    document.getElementById("feedbackForm").requestSubmit();
  }, []);

  return (
    <>
      {showLogoutDialog && (
        <FormDialog
          open={showLogoutDialog}
          handleClose={closeLogoutDialog}
          loading={isLogoutLoading}
          handleSubmit={handleLogout}
          buttonTxt="Logout"
          title="Confirmation: Log Out"
          cancelBtn={true}
          alignActions={"center"}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure you want to log out?
          </Typography>
        </FormDialog>
      )}

      {showFeedBackDialog && (
        <FormDialog
          open={showFeedBackDialog}
          handleClose={closeFeedBackDialog}
          loading={isLogoutLoading}
          handleSubmit={handleFeedBackForm}
          buttonTxt="Submit"
          cancelBtn={true}
          width={"800px"}
          className="feedback-form-dialog"
          title="TaskBoard Beta – We’d Love Your Feedback!">
          <FeedbackDialogContent
            schema={schema}
            handleClose={closeFeedBackDialog}
          />
        </FormDialog>
      )}
      {openMergeBoard && (
        <MergeBoard
          close={closeMergeBoard}
          open={openMergeBoard}
          admin={true}
        />
      )}
      <div className="header-right">
        {Object.hasOwn(user, "first_name") && (
          <Box>
            <Stack direction="row" justifyContent={"end"} className="align-items-center">
            <Notification/>
              <Tooltip title={TooltipName.PROFILE.PROFILE}>
                <CustomButton
                  className="profile-btn"
                  onClick={handleClick}
                  endIcon={
                    <KeyboardArrowDownIcon className="profile-down-arrow" />
                  }>
                  <Avatar
                    title={`${user.first_name} ${user.last_name}`}
                    user_image={user?.user_image}
                    className="user-avatar"
                    style={
                      !hasImage(user?.user_image) && {
                        bgcolor: user?.profile_color?.background,
                        color: user?.profile_color?.text,
                      }
                    }
                    isDisable={true}>
                    {userName}
                  </Avatar>
                  {!isMobile && (
                    <div>
                      <Typography className="user-name">
                        {user?.first_name} {user.last_name}
                      </Typography>
                    </div>
                  )}
                </CustomButton>
              </Tooltip>
            </Stack>

            <CustomMenu
              id="account-menu"
              className="profile-header"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}>
              <CustomMenuItem disableRipple sx={{ cursor: "default" }}>
                <Stack className="profile-container">
                  <UploadImage
                    user={user}
                    userName={userName}
                    setAnchorEl={handleClose}
                  />

                  <ListItemText
                    className="ml-2"
                    primary={
                      <React.Fragment>
                        <Typography className="profile-dropdown-name">
                          {user.first_name} {user.last_name}
                        </Typography>
                      </React.Fragment>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography className="profile-dropdown-email">
                          {user.email}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </Stack>
              </CustomMenuItem>
              {profileMenuList.map((item, index) => (
                <ProfileMenuItem
                  key={`profile-menu-${index}`}
                  menuItem={item}
                  handleMenuClick={handleMenuClick}
                />
              ))}
            </CustomMenu>
          </Box>
        )}
      </div>
    </>
  );
}

export default React.memo(Profile);
